import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_InterventionStepsBar = _resolveComponent("InterventionStepsBar")!
  const _component_StepOne = _resolveComponent("StepOne")!
  const _component_StepTwo = _resolveComponent("StepTwo")!
  const _component_StepThree = _resolveComponent("StepThree")!
  const _component_StepFour = _resolveComponent("StepFour")!
  const _component_StepFive = _resolveComponent("StepFive")!
  const _component_StepSix = _resolveComponent("StepSix")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!
  const _component_AstreinteModal = _resolveComponent("AstreinteModal")!
  const _component_JourFerieModal = _resolveComponent("JourFerieModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("h1", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('intervention.title')) + " ", 1),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.definition" }),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.droitDemande" }),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.sauvegardeEtapes" }),
        _createVNode(_component_ReglePastille, { cle: "demandeIntervention.unSeulSite" })
      ]),
      _createVNode(_component_InterventionStepsBar, { step: _ctx.step }, null, 8, ["step"]),
      _createElementVNode("div", _hoisted_2, [
        (this.step === 1)
          ? (_openBlock(), _createBlock(_component_StepOne, {
              key: 0,
              title: _ctx.$t('siteSelection.searchBar.title.request.intervention'),
              "regle-cle": "demandeIntervention.listeSites",
              onNext: _ctx.next
            }, null, 8, ["title", "onNext"]))
          : _createCommentVNode("", true),
        (this.step === 2)
          ? (_openBlock(), _createBlock(_component_StepTwo, { key: 1 }))
          : _createCommentVNode("", true),
        (this.step === 3)
          ? (_openBlock(), _createBlock(_component_StepThree, {
              key: 2,
              "display-radio": true,
              "open-info-equipement": false
            }))
          : _createCommentVNode("", true),
        (this.step === 4)
          ? (_openBlock(), _createBlock(_component_StepFour, { key: 3 }))
          : _createCommentVNode("", true),
        (this.step === 5)
          ? (_openBlock(), _createBlock(_component_StepFive, { key: 4 }))
          : _createCommentVNode("", true),
        (this.step === 6)
          ? (_openBlock(), _createBlock(_component_StepSix, { key: 5 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_BottomNavigation, {
      back: _ctx.back,
      cancel: _ctx.cancel,
      confirm: _ctx.request,
      confirmButtonDisabled: !_ctx.isValid,
      first: _ctx.step === 1,
      last: _ctx.step === 6,
      next: _ctx.next,
      regleCle: _ctx.step === 5 ? 'demandeIntervention.suivantEtape5' : undefined
    }, null, 8, ["back", "cancel", "confirm", "confirmButtonDisabled", "first", "last", "next", "regleCle"]),
    (_ctx.isHeureAstreinte && _ctx.astreinteModalOpen)
      ? (_openBlock(), _createBlock(_component_AstreinteModal, {
          key: 0,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.astreinteModalOpen = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isJourFerie && _ctx.jourFerieModalOpen)
      ? (_openBlock(), _createBlock(_component_JourFerieModal, {
          key: 1,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jourFerieModalOpen = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}